"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @property Initial - секуномер не запущен
 * @property Running - секуномер запущен
 * @property Paused - секуномер приостановлен
 */
var EStopwatchState;
(function (EStopwatchState) {
    EStopwatchState[EStopwatchState["Initial"] = 0] = "Initial";
    EStopwatchState[EStopwatchState["Running"] = 1] = "Running";
    EStopwatchState[EStopwatchState["Paused"] = 2] = "Paused";
})(EStopwatchState || (EStopwatchState = {}));
/**
 * @description Секундомер. Позволяет приостанавливать/возобновлять время.
 * Время возвращается в миллисекундах.
 */
var Stopwatch = /** @class */ (function () {
    function Stopwatch() {
        this.runningTime = 0;
        this.lastIntervalStartTime = 0;
        this.state = EStopwatchState.Initial;
    }
    Stopwatch.prototype.start = function () {
        if (this.state !== EStopwatchState.Initial) {
            return;
        }
        this.state = EStopwatchState.Running;
        this.lastIntervalStartTime = performance.now();
    };
    Stopwatch.prototype.stop = function () {
        if (this.state === EStopwatchState.Initial) {
            return 0;
        }
        // Если секундомер приостановлен, конечное время уже посчитано в методе pause
        var runningTime = this.state === EStopwatchState.Paused
            ? this.runningTime
            : this.runningTime + performance.now() - this.lastIntervalStartTime;
        this.runningTime = 0;
        this.lastIntervalStartTime = 0;
        this.state = EStopwatchState.Initial;
        return runningTime;
    };
    Stopwatch.prototype.pause = function () {
        // Поставить на паузу можем только запущенный секундомер
        if (this.state !== EStopwatchState.Running) {
            return;
        }
        this.runningTime += performance.now() - this.lastIntervalStartTime;
        this.state = EStopwatchState.Paused;
    };
    Stopwatch.prototype.resume = function () {
        // Возобновить можем только приостановленный секундомер
        if (this.state !== EStopwatchState.Paused) {
            return;
        }
        this.lastIntervalStartTime = performance.now();
        this.state = EStopwatchState.Running;
    };
    Stopwatch.prototype.getTime = function () {
        return this.runningTime;
    };
    return Stopwatch;
}());
exports.Stopwatch = Stopwatch;
//# sourceMappingURL=stopwatch.js.map